import { useMemo } from "react";

import { useUserStore } from "@stores/index";
import { BusinessType } from "@interfaces/rest";
import { Dropdown } from "@components/index";

export const BusinessSelector = ({
  height = "medium",
  variant = "filter",
  width,
  value = "",
  excludeTypes = [],
  onSetBusiness,
  error,
  dataTestid,
}: {
  height?: "small" | "medium";
  width?: string;
  defaultIsEmpty?: boolean;
  variant?: "filter" | "formField";
  value?: string;
  excludeTypes?: BusinessType[];
  onSetBusiness?: (businessId: string) => void;
  error?: string;
  dataTestid?: string;
}) => {
  const businesses = useUserStore(({ businesses }) => businesses);

  const items = useMemo(
    () =>
      businesses
        .filter(({ type }) => !excludeTypes.includes(type))
        .map(({ uniqueId, name }) => ({
          id: uniqueId,
          title: name,
        })),
    [businesses, excludeTypes],
  );

  const handleSelectBusiness = (id: string) => {
    if (onSetBusiness) {
      onSetBusiness(id);
    }
  };

  return (
    <Dropdown
      height={height}
      width={width}
      chevronType={variant === "filter" ? "smallBlue" : "default"}
      preText={variant === "filter" ? "Business: " : ""}
      textAlignLeft
      classNameSelected={
        variant === "filter" ? "font-bold text-primary-300" : ""
      }
      label={variant === "formField" ? "Business" : ""}
      items={items}
      value={value}
      onSelect={handleSelectBusiness}
      error={error}
      dataTestid={dataTestid}
    />
  );
};
